<template>
  <div :id="eid"></div>
</template>

<script>
import { genPlayerInstance } from './config'
import { uuidv4 } from '@/utils'
export default {
  data () {
    return {
      eid: 'player:' + uuidv4(),
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      const playerIns = genPlayerInstance({
        id: this.eid,
        autoplay: false,
        autoplayMuted: false,
        // loop: true,
        playsinline: true,
        inactive: 1500,
        ...this.$attrs
      })
      this.ins = playerIns
    },
  },
}
</script>

